import { AxiosError } from "axios";
import { AppCurrentUser, LatLng } from "../types";
import http from "../common/axios";
import { auth } from "../firebase";
import { captureException } from "@sentry/react";

export async function getUserData(): Promise<AppCurrentUser | null> {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await http.get("/users");

    const user: AppCurrentUser = {
      id: response.data.id,
      email: response.data.email,
      points: response.data.points,
      referral: response.data.referral,
      photoUrl: response.data.photo_url,
      displayName: response.data.display_name,
      createdAt: new Date(response.data.created_at),
      updatedAt: new Date(response.data.updated_at),
    };

    return user;
  } catch (error) {
    if (error instanceof AxiosError && !(error.status == 401 || error.status == 404)) {
      captureException(error);
    }

    throw error;
  }
}

export async function createUser(
  position: LatLng,
  city: string,
  name?: string,
): Promise<void> {
  const user = auth.currentUser;

  if (!user) return;
  try {
    await http.put("/users", {
      email: user.email,
      photo_url: user.photoURL,
      display_name: name ?? user.displayName,
      terms: true,
      categories: [],
      location: {
        latitude: position.latitude,
        longitude: position.longitude,
        city: city,
      },
      marketing: JSON.parse(window.localStorage.getItem("marketing") || "false"),
    });
  } catch (error) {
    captureException(error);
    throw error;
  }
  window.localStorage.removeItem("marketing");
}
